import { Controller } from "@hotwired/stimulus"

// Couples can_create / can_publish checkboxes per row.
//
// Rules:
//   - Checking "Publier" auto-checks "Créer"
//   - Unchecking "Créer" auto-unchecks "Publier"
//   - Unchecking "Publier" does NOT uncheck "Créer"
export default class extends Controller {
  static targets = ["row"]

  createChanged(event) {
    const row = event.target.closest("[data-story-permission-target='row']")
    if (!row) return

    const publishBox = row.querySelector("[data-role='publish']")
    if (!publishBox) return

    // Unchecking create → uncheck publish
    if (!event.target.checked) {
      publishBox.checked = false
    }
  }

  publishChanged(event) {
    const row = event.target.closest("[data-story-permission-target='row']")
    if (!row) return

    const createBox = row.querySelector("[data-role='create']")
    if (!createBox) return

    // Checking publish → auto-check create
    if (event.target.checked) {
      createBox.checked = true
    }
  }
}
